import * as yup from 'yup';

// Define form data type
export type SignInData = {
  email: string;
  password: string;
};

// Define validation schema
export const signInSchema = yup.object({
  email: yup
    .string()
    .email('Invalid email format')
    .required('Email is required'),
  password: yup
    .string()
    .min(6, 'Password must be at least 6 characters')
    .required('Password is required'),
});

// Default values for the sign-in form
export const signInDefaultValues: SignInData = {
  email: '',
  password: '',
};
